"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftTrackersFromGroupingResponseToJSON = exports.GetNftTrackersFromGroupingResponseFromJSONTyped = exports.GetNftTrackersFromGroupingResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetNftTrackersFromGroupingResponseFromJSON(json) {
    return GetNftTrackersFromGroupingResponseFromJSONTyped(json, false);
}
exports.GetNftTrackersFromGroupingResponseFromJSON = GetNftTrackersFromGroupingResponseFromJSON;
function GetNftTrackersFromGroupingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftTrackers': !(0, runtime_1.exists)(json, 'nftTrackers') ? undefined : (json['nftTrackers'].map(_1.NftTrackerFromJSON)),
    };
}
exports.GetNftTrackersFromGroupingResponseFromJSONTyped = GetNftTrackersFromGroupingResponseFromJSONTyped;
function GetNftTrackersFromGroupingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftTrackers': value.nftTrackers === undefined ? undefined : (value.nftTrackers.map(_1.NftTrackerToJSON)),
    };
}
exports.GetNftTrackersFromGroupingResponseToJSON = GetNftTrackersFromGroupingResponseToJSON;
